import { UseQueryResult } from "@tanstack/react-query";

import PaginatedGroup from "@/components/ui/PaginatedGroup";
import GroupCard from "@/components/ui/PaginatedGroup/GroupCard";
import { useUser } from "@/context/user-context";
import { useDatasetsByPromptId } from "@/queries";
import { DatasetRead } from "@/types/datasets";

const DatasetGroup = ({ promptId }: { promptId: number }) => {
  const workspaceId = useUser().activeWorkspaceId;
  const Query = (
    page: number,
    pageSize: number,
  ): UseQueryResult<{ datasets: DatasetRead[]; total: number; pages: number }, unknown> | null => {
    const result = useDatasetsByPromptId({
      workspace_id: workspaceId!,
      prompt_id: promptId,
      page,
      per_page: pageSize,
    });

    if (!result.data) {
      return result as unknown as UseQueryResult<
        { datasets: DatasetRead[]; total: number; pages: number },
        unknown
      > | null;
    }

    return {
      ...result,
      data: {
        datasets: result.data.datasets,
        total: result.data.total,
        pages: result.data.pages,
      },
    } as UseQueryResult<{ datasets: DatasetRead[]; total: number; pages: number }, unknown>;
  };

  return (
    <PaginatedGroup<DatasetRead, { datasets: DatasetRead[]; total: number; pages: number }>
      title="Datasets"
      query={Query}
      extractData={data => ({
        data: data.datasets,
        totalItems: data.total,
        totalPages: data.pages,
      })}
      renderItem={item => (
        <GroupCard
          title={item.dataset_group?.name ?? ""}
          version={item.version_number}
          to={`/workspace/${workspaceId}/dataset-groups/${item.dataset_group_id}/dataset/${item.id}`}
        />
      )}
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      getItemKey={(item: any) => item.id}
    />
  );
};

export default DatasetGroup;
